import { Bar, BarChart, CartesianGrid, Legend, ResponsiveContainer, Tooltip, XAxis, YAxis } from "recharts";
import Card from "../../../Component/RetailerComponents/Card";
import { money, pct } from "../../../utils/helpers";

export default function InsightsSection({
  topProduct, lowProduct,
  topProducts,
  byCustomer,
  mostClaims,
  mostCreditNotes,
  kpis,
  mode, byState, byDistrict
}) {
  return (
   <div className="grid grid-cols-1 gap-6 lg:grid-cols-2">
    <Card title="Product Comparison (Top/Low)">
    <div className="text-center">
        Coming Soon...
    </div>
        {/* <div className="space-y-3">
        <div className="rounded-2xl border border-blue-100 bg-blue-50 p-4">
            <p className="text-xs font-semibold text-slate-500">Top Product</p>
            <p className="text-sm font-semibold text-slate-900">{topProduct?.name || "—"}</p>
            <p className="mt-1 text-xs font-semibold text-slate-600">
            Revenue: {money(topProduct?.revenue || 0)} • Units: {topProduct?.units || 0}
            </p>
        </div>

        <div className="rounded-2xl border border-blue-100 bg-white p-4">
            <p className="text-xs font-semibold text-slate-500">Low Product</p>
            <p className="text-sm font-semibold text-slate-900">{lowProduct?.name || "—"}</p>
            <p className="mt-1 text-xs font-semibold text-slate-600">
            Revenue: {money(lowProduct?.revenue || 0)} • Units: {lowProduct?.units || 0}
            </p>
        </div>

        <div className="mt-2 h-56">
            <ResponsiveContainer width="100%" height="100%">
            <BarChart data={topProducts}>
                <CartesianGrid strokeDasharray="3 3" />
                <XAxis dataKey="name" />
                <YAxis />
                <Tooltip formatter={(v) => money(v)} />
                <Legend />
                <Bar dataKey="revenue" name="Revenue" />
            </BarChart>
            </ResponsiveContainer>
        </div>
        </div> */}
    </Card>


    <Card title={mode === "state" ? "State Wise Table" : "District Wise Table"}>

        <div className="text-center">
            Coming Soon...
        </div>
        {/* <div className="overflow-x-auto">
            <table className="w-full text-sm">
            <thead>
                <tr className="border-b text-left text-slate-700">
                <th className="py-3">{mode === "state" ? "State" : "District"}</th>
                {mode === "district" ? <th>State</th> : null}
                <th>Revenue</th>
                <th>Units</th>
                <th>Claims</th>
                <th>Credit Notes</th>
                <th>CN Ratio</th>
                </tr>
            </thead>
            <tbody>
                {(mode === "state" ? byState : byDistrict).slice(0, 12).map((x) => (
                <tr key={mode === "state" ? x.name : x.key} className="border-b hover:bg-slate-50">
                    <td className="py-3 font-semibold text-slate-900">{x.name}</td>
                    {mode === "district" ? <td className="font-semibold text-slate-700">{x.state}</td> : null}
                    <td className="font-semibold">{money(x.revenue)}</td>
                    <td className="font-semibold text-slate-700">{x.units}</td>
                    <td className="font-semibold text-slate-700">{x.claims}</td>
                    <td className="font-semibold">{money(x.creditNotes)}</td>
                    <td className="font-semibold text-blue-700">
                    {x.revenue > 0 ? pct(x.creditNotes / x.revenue) : "0.0%"}
                    </td>
                </tr>
                ))}
            </tbody>
            </table>
        </div> */}
        </Card>
    {/* <Card title="Who is mostly sale/claim?">
        <div className="rounded-2xl border border-blue-100 bg-white p-4">
        <p className="text-xs font-semibold text-slate-500">Top by Revenue</p>
        <div className="mt-2 space-y-2">
            {byCustomer.slice(0, 5).map((c) => (
            <div key={c.code} className="flex items-center justify-between rounded-xl border border-blue-100 bg-blue-50 p-3">
                <div>
                <p className="text-sm font-semibold text-slate-900">{c.name}</p>
                <p className="text-xs font-semibold text-slate-600">Code: {c.code}</p>
                </div>
                <p className="text-sm font-semibold text-blue-700">{money(c.revenue)}</p>
            </div>
            ))}
        </div>
        </div>

        <div className="mt-4 rounded-2xl border border-blue-100 bg-white p-4">
        <p className="text-xs font-semibold text-slate-500">Top by Claims</p>
        <div className="mt-2 space-y-2">
            {mostClaims.map((c) => (
            <div key={c.code} className="flex items-center justify-between rounded-xl border border-blue-100 bg-white p-3">
                <div>
                <p className="text-sm font-semibold text-slate-900">{c.name}</p>
                <p className="text-xs font-semibold text-slate-600">Code: {c.code}</p>
                </div>
                <p className="text-sm font-semibold text-slate-900">{c.claims}</p>
            </div>
            ))}
        </div>
        </div>
    </Card>

    <Card title="Credit Notes Ratio & Leaders">
        <div className="rounded-2xl border border-blue-100 bg-blue-50 p-4">
        <p className="text-xs font-semibold text-slate-500">Credit Note Ratio</p>
        <p className="text-lg font-semibold text-slate-900">{pct(kpis.creditRatio)}</p>
        <p className="mt-1 text-xs font-semibold text-slate-600">
            CN: {money(kpis.creditNotes)} / Revenue: {money(kpis.revenue)}
        </p>
        </div>

        <div className="mt-4 rounded-2xl border border-blue-100 bg-white p-4">
        <p className="text-xs font-semibold text-slate-500">Who raises most Credit Notes</p>
        <div className="mt-2 space-y-2">
            {mostCreditNotes.map((c) => (
            <div key={c.code} className="flex items-center justify-between rounded-xl border border-blue-100 bg-white p-3">
                <div>
                <p className="text-sm font-semibold text-slate-900">{c.name}</p>
                <p className="text-xs font-semibold text-slate-600">Code: {c.code}</p>
                </div>
                <p className="text-sm font-semibold text-slate-900">{money(c.creditNotes)}</p>
            </div>
            ))}
        </div>
        </div>
    </Card> */}
    </div>
  );
}
